import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";
import {useContext} from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {ModalLauncher, OnePaneDialog} from "@khanacademy/wonder-blocks-modal";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";
import {useGuideState} from "@khan/guide-state";

import {PreviewModeContext} from "./PreviewModeContext.ts";

interface Props {
    currentMessage: string;
}

function PreviewModeSubmitModal({currentMessage}: Props): React.ReactElement {
    const conversation = useGuideState("conversation");
    const firstOutgoingMessageIndex = conversation.findIndex(
        (message) => message.type === "outgoing",
    );
    const isMobile = window.innerWidth <= 450;
    const previewModeContextValue = useContext(PreviewModeContext);
    return (
        // eslint-disable-next-line @khan/frontend/require-logical-properties-for-rtl -- moving file to new location with new rules
        <View style={{marginRight: spacing.xSmall_8}}>
            <ModalLauncher
                modal={({closeModal}) => (
                    <OnePaneDialog
                        title={t`Ready to submit?`}
                        style={styles.modal}
                        content={
                            <View>
                                <LabelMedium>
                                    {t`Are you ready to submit your assignment? Once submitted, you can't make changes. Please take a moment to review your work.`}
                                </LabelMedium>
                            </View>
                        }
                        footer={
                            <View style={styles.footer}>
                                <Button
                                    kind="tertiary"
                                    onClick={closeModal}
                                    style={styles.notYetButton}
                                >
                                    {t`Not yet`}
                                </Button>
                                <Button
                                    kind="primary"
                                    onClick={() => {
                                        previewModeContextValue !== undefined &&
                                            previewModeContextValue[
                                                "handlePreviewModeSubmitButtonClick"
                                            ]();
                                    }}
                                >
                                    {t`Yes, submit now`}
                                </Button>
                            </View>
                        }
                    />
                )}
            >
                {({openModal}) => (
                    <Button
                        onClick={openModal}
                        kind="secondary"
                        disabled={
                            firstOutgoingMessageIndex === -1 ||
                            currentMessage.length > 0
                        }
                        testId="submit-assignment-modal-launcher"
                    >
                        {isMobile ? t`Submit` : t`Submit this assignment`}
                    </Button>
                )}
            </ModalLauncher>
        </View>
    );
}

export default PreviewModeSubmitModal;

const styles = StyleSheet.create({
    modal: {
        height: 272,
    },
    notYetButton: {
        // eslint-disable-next-line @khan/frontend/require-logical-properties-for-rtl -- moving file to new location with new rules
        marginRight: spacing.medium_16,
    },
    footer: {
        flexDirection: "row",
    },
});
